/**
 * This code imports the createSlice function from the '@reduxjs/toolkit' library and
 * defines an initial state object with three boolean properties.
 *
 * The screensSlice variable is created using the createSlice function, which takes
 *  an object with a name property and an initialState property.
 * It also takes a reducers property, which is an object containing
 * functions that modify the state.
 *
 * The setHomeScreen and setArScreen functions are defined as reducers
 * in the reducers object. They both toggle the values of their respective
 * state properties and the instructionsScreen property.
 *
 * The screensSlice.actions object is created with the setHomeScreen and
 * setArScreen functions as its properties.
 *
 * Finally, the screensSlice.reducer function is exported as the default export of this module.
 */

import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  homeScreen: true,
  instructionsScreen: false,
  arScreen: false
}

export const screensSlice = createSlice({
  name: 'screens',
  initialState,
  reducers: {
    setHomeScreen: (state) => {
      state.homeScreen = !state.homeScreen
      state.instructionsScreen = !state.instructionsScreen
    },
    setArScreen: (state) => {
      state.arScreen = !state.arScreen
      state.instructionsScreen = !state.instructionsScreen
    }
  }
})

export const { setHomeScreen, setArScreen } = screensSlice.actions

export default screensSlice.reducer
